<template>
  <v-card>
    <v-row>
      <v-col cols="12">
        <v-card class="mb-5 pa-4">
          <v-card-title>
            <span class="headline"
              >Stock Transfer Number : #{{ transferDetails.code }}</span
            > </v-card-title
          ><br />
          <v-card-subtitle>
            <div>
              <strong>Status:</strong>{{ transferDetails.status }} <br />
              <strong>Date:</strong> {{ transferDetails.date }} <br />
              <strong>Out Branch:</strong>
              {{ transferDetails.out_branch.name }} <br />
              <strong>Out Store:</strong> {{ transferDetails.out_store.name }}
              <br />
              <strong>In Branch:</strong> {{ transferDetails.in_branch.name }}
              <br />
              <strong>In Store:</strong> {{ transferDetails.in_store.name }}
              <br />
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table
      v-if="items && items.length > 0"
      :headers="itemHeaders"
      :items="items"
      dense
      item-key="id"
    >
      <template v-slot:item="{ item, index }">
        <tr :class="[index % 2 === 0 ? 'dark-row' : 'light-row', 'custom-row']">
          <td>{{ item.product.product_code }}</td>
          <td>{{ item.batch ? item.batch.batch_code : "N/A" }}</td>
          <td>{{ item.quantity }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { StockTransferService } from "@/services/stockTransfer-service.js";

export default {
  data() {
    return {
      transferDetails: {},
      items: [],
      loading: false,
      itemHeaders: [
        { text: "Product Name", value: "product_code" },
        { text: "Batch code", value: "batch_id" },
        { text: "Quantity", value: "quantity" },
      ],
    };
  },
  created() {
    this.fetchTransferDetails();
  },
  methods: {
    async fetchTransferDetails() {
      try {
        const response = await StockTransferService.getTransferDetails(
          this.$route.params.uuid
        );
        this.transferDetails = response;
        this.fetchItems(this.transferDetails.id);
      } catch (error) {
        console.error("Error fetching GRN details:", error);
      }
    },

    async fetchItems(id) {
      try {
        const items = await StockTransferService.getItemsBytransferId(id);
        this.items = items;
      } catch (error) {
        console.error("Error fetching items for GRN:", error);
      }
    },
  },
};
</script>
